import { Button, Col, Row } from 'reactstrap'
import { APPLICATION_SETTINGS } from '../../../../common/constants'
import { OfferContactDisplayProps } from '../types'
import { formatItemDisplayLabel } from '../utils'

const OfferContactDisplay = (props: OfferContactDisplayProps) => {
    const { selectedContacts, items, handleContactRemove } = props

    const areaUnit = APPLICATION_SETTINGS.AREA_UNIT
    const currency = APPLICATION_SETTINGS.CURRENCY

    return (
        <>
            {selectedContacts.map((contact, index: number) => {
                const contactKey = contact.contact_id || contact.contact_company_collection[0]?.contact_id || `contact-${index}`

                const displayName = contact.contact_id ? contact.contact_name : contact.contact_company_collection[0]?.contact_name || ''
                const displayEmail = contact.contact_id ? contact.contact_email : contact.contact_company_collection[0]?.contact_email || ''

                return (
                    <Row className="border-top pt-4" key={`contact-${contactKey}`}>
                        <Col sm={12} className="border-bottom pb-4 mb-4 d-flex align-items-center">
                            <div className="flex-grow-1">
                                <div className="fw-medium fs-13 mb-2">
                                    {displayName}, {displayEmail}
                                </div>
                                {items?.map((item) => (
                                    <div className="text-secondary fs-11 fw-light mb-1" key={item.id}>
                                        {formatItemDisplayLabel(item, areaUnit, currency)}
                                    </div>
                                ))}
                            </div>
                            <Button
                                color="link"
                                className="text-danger"
                                onClick={() => handleContactRemove(contact.contact_id, contact.contact_email)}
                            >
                                <i className="mdi mdi-trash-can-outline fs-17"></i>
                            </Button>
                        </Col>
                    </Row>
                )
            })}
        </>
    )
}

export default OfferContactDisplay
